<template>
<div v-if="show">

    <router-link tag="a" :to="`/bookings/${commingVideochat.id}`" class="chat-alert past"  v-if="commingVideochat.timeslot.datetime < now && commingVideochat.status=='CONFIRMED'">
        Tienes una videoconsulta que debería haber comenzado {{commingVideochat.timeslot.datetime | moment("from", "now")}}
    </router-link>

    <router-link tag="a" :to="`/bookings/${commingVideochat.id}`" class="chat-alert success" v-if="commingVideochat.timeslot.datetime >= now && commingVideochat.status=='CONFIRMED'" >
        La videoconsulta #{{commingVideochat.code}} comenzará en {{commingVideochat.timeslot.datetime | moment("from", "now")}}
    </router-link>
    
    <router-link tag="a" :to="`/bookings/${commingVideochat.id}`" class="chat-alert success" v-if="commingVideochat.status=='ON_COURSE'"  >
        Videoconsulta #{{commingVideochat.code}} en curso
    </router-link>

</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'ComingChat',
    data () {
        return {
            now: this.$moment().format('YYYY-MM-DD HH:mm:ss')
        }
    },
    computed: {
        ...mapGetters(['commingVideochat']),
        show: function(){
            // if( this.commingVideochat && ( this.$route.name != 'bookingDetail' && this.$route.name != 'bookingAttend' ) ){
            if( this.commingVideochat ){
                return true
            }
            // if( this.commingVideochat && ( this.$route.name == 'bookingDetail' || this.$route.name == 'bookingAttend') && this.$route.params.id != this.commingVideochat.id ){
            //     return true
            // }
            return false

        }
    },
}
</script>

<style scoped>
.chat-alert{
    margin-top: 3px;
    width: 100%;
    padding: 2px 9px;
    color: #fff;
    font-size: .8rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}
.chat-alert .btn{
    display: none;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}
/* .chat-alert:hover .btn{
    display: block;
}
.chat-alert:hover{
    padding: 12px 15px;
    font-size: 1rem;
} */

.chat-alert.past{    
    background-color: rgb(180, 30, 30);
}
.chat-alert.success{    
    background-color: rgb(63, 209, 19);
}
</style>
